import React from 'react';
import './Legal.css';

function Legal() {
  return (
    <div >
      <div className='terms_condition'>
      <h1 className='terms'><span className='text-[#0094c7]'>Terms</span> & <span className='text-[#0094c7]'>Conditions</span></h1>
      <p className='terms_last'>Last updated: Jan, 2025</p>
      </div>
      
        <hr />
        <hr />
        <div className='legal_container'>

      <div className='legal_card'>
        <p>
        Welcome to XStakUp (&quot;we,&quot; &quot;our,&quot; &quot;us&quot;). These Terms and Conditions govern your use of our website, services, and any related products or offerings. By accessing or using our services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not use our services.
        </p>
        <p className='mt-[20px]'><b>1. Acceptance of Terms</b></p>
        <p>
          By using our website or services, you confirm that you are at least 18 years old and have the legal capacity to enter into a binding agreement. You also agree to comply with these Terms and Conditions and any additional guidelines we provide.
        </p>

        <p className='mt-[20px]'><b>2. Acceptance of Terms</b></p>
        <p>We provide the following services:</p>
        <ul className='list-disc pl-5'>
          <li>
            Application Development
          </li>
          <li>
            Blockchain
          </li>
          <li>
            Brand Identity Design
          </li>
          <li>
            Product Design
          </li>
          <li>
             Other services not listed
          </li>
        </ul>

        <p>
        The scope, timeline, and cost of these services will be outlined in a separate agreement or proposal provided to you.
        </p>

        <p className='mt-[20px]'><b>3. Intellectual Propety</b></p>
        <ul className='list-decimal pl-6'>
          <li>
          <b>Ownership:</b> All intellectual property rights, including but not limited to software, designs, trademarks, and content created by us during the course of providing services, remain our property unless otherwise agreed in writing.
          </li>
          <li>
           <b>Client Materials:</b>  You retain ownership of any materials, data, or content you provide to us for the purpose of delivering our services.
          </li>
          <li>
           <b>License:</b>  Upon full payment, we grant you a non-exclusive, non-transferable license to use the deliverables for their intended purpose.
          </li>
        </ul>

        <p className='mt-[20px]'><b>4. Payment Terms</b></p>
        <ul className='list-decimal pl-5'>
          <li>
          <b>Fees:</b> Our fees will be outlined in the project proposal or agreement. Payment terms, including due dates and methods, will also be specified.
          </li>
          <li>
           <b>Late Payments:</b> Late payments may incur interest or additional fees as outlined in the agreement.
          </li>
          <li>
           <b>Refunds:</b>  Upon full payment, we grant you a non-exclusive, non-transferable license to use the deliverables for their intended purpose.
          </li>
        </ul>

        <p className='mt-[20px]'><b>5. Confidentiality</b></p>
        <p>Both parties agree to maintain the confidentiality of any proprietary or confidential information disclosed during the course of the project. This obligation continues even after the project is completed.</p>
        
        <p className='mt-[20px]'><b>5. Limitation of Liability</b></p>
        <ul className='list-decimal pl-5'>
          <li>
          <b>No Warranty:</b> Our services are provided &quot;as is&quot; and &quot;as available&quot; without any warranties, express or implied.
          </li>
          <li>
           <b>Limitation:</b> We are not liable for any indirect, incidental, or consequential damages arising from the use of our services or website.
          </li>
          <li>
           <b>Maximun Liability:</b>  Upon full payment, we grant you a non-exclusive, non-transferable license to use the deliverables for their intended purpose.
          </li>
        </ul>

        <p className='mt-[20px]'><b>7. Termination</b></p>
        <ul className='list-decimal pl-5'>
          <li>
          <b>By Us:</b> We reserve the right to terminate or suspend your access to our services at any time, with or without notice, for any reason, including breach of these Terms and Conditions.
          </li>
          <li>
           <b>By You:</b> You may terminate your engagement with us by providing written notice, subject to any payment obligations outlined in the agreement.
          </li>
        </ul>

        <p className='mt-[20px]'><b>8. Third-Party Services</b></p>
        <p>
        Our services may include or rely on third-party tools, platforms, or services. We are not responsible for the availability, functionality, or content of these third-party services.
        </p>

        <p className='mt-[20px]'><b>9. Governing Law</b></p>
        <p>
        These Terms and Conditions are governed by and construed in accordance with the laws of Nigeria. Any disputes arising from these terms will be resolved exclusively in the courts of Nigeria.
        </p>

        <p className='mt-[20px]'><b>10. Changes to Terms</b></p>
        <p>
        We reserve the right to update or modify these Terms and Conditions at any time. Any changes will be effective immediately upon posting on our website. Your continued use of our services after changes are posted constitutes your acceptance of the revised terms.
        </p>

        <p className='mt-[20px]'><b>11. Contact Us</b></p>
        <p>
        If you have any questions or concerns about these Terms and Conditions, please contact us at:
        </p>
        <ul className='list-disc pl-5'>
          <li>
          <b>Email:</b><a href="mailTo:Build@xstakup.com" className='text-[#0094c7]'> Build@xstakup.com</a> 
          </li>
          <li>
           <b>Phone:</b><b>Email:</b><a href="tel:+2348062894114" className='text-[#0094c7]'> +2348062894114</a> 
          </li>
          <li>
             <b>Address:</b> 19 Allen Road Surulere, Lagos State.
          </li>
        </ul>

        <p className='mt-[20px]'><b>12. Entire Aggrement</b></p>
        <p>
        These Terms and Conditions, along with any additional agreements or proposals, constitute the entire agreement between you and FutureXTech (XstakUp) regarding your use of our services.
        </p>

        <p className='mt-[20px]'><b>12. Acknowledgemnt</b></p>
        <p>
        By using our services, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.
        </p>

        </div>



      </div>
    </div>
  )
}

export default Legal;
